import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../utils";

const paymentRequest = async (url, data) => {
    try {
        const res = await axios({
            method: "post",
            url: getConfig.API_URL + url,
            data,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
}

export const applyCoupon = createAsyncThunk('applyCoupon', async (data) => {
    const body = {
        payment_type: data?.payment_type,
    }
    if (data?.coupon_code) body.coupon_code = data.coupon_code
    if (data?.coupon_id) body.coupon_id = data.coupon_id
    if (data?.payment_type === 'Exam Fee' && data?.exam_id != null) {
        body.exam_id = Number(data.exam_id)
    }
    if (data?.payment_type === 'Registration Fee' && data?.institute_branch_id != null) {
        body.institute_branch_id = Number(data.institute_branch_id)
    }
    return paymentRequest('apply_coupon', body)
})

export const createInstituteOrder = createAsyncThunk('createInstituteOrder', async (data) => {
    const body = {
        institute_branch_id: data?.institute_branch_id,
    }
    if (data?.coupon_id != null) body.coupon_id = data.coupon_id
    if (data?.coupon_code) body.coupon_code = data.coupon_code
    return paymentRequest('institute_payment/create_order', body)
})

export const verifyInstituteOrder = createAsyncThunk('verifyInstituteOrder', async (data) => {
    return paymentRequest('institute_payment/verify_order', {
        razorpay_order_id: data?.razorpay_order_id,
        razorpay_payment_id: data?.razorpay_payment_id,
        razorpay_signature: data?.razorpay_signature,
    })
})

export const createExamOrder = createAsyncThunk('createExamOrder', async (data) => {
    const body = {
        exam_id: data?.exam_id,
    }
    if (data?.coupon_id != null) body.coupon_id = data.coupon_id
    if (data?.coupon_code) body.coupon_code = data.coupon_code
    return paymentRequest('exam_payment/create_order', body)
})

export const verifyExamOrder = createAsyncThunk('verifyExamOrder', async (data) => {
    return paymentRequest('exam_payment/verify_order', {
        razorpay_order_id: data?.razorpay_order_id,
        razorpay_payment_id: data?.razorpay_payment_id,
        razorpay_signature: data?.razorpay_signature,
    })
})

const statusRequest = async (url, params) => {
    try {
        const res = await axios({
            method: 'get',
            url: getConfig.API_URL + url,
            params,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
}

const listRows = (res) => {
    const raw = res?.data?.data
    if (Array.isArray(raw)) return raw
    if (Array.isArray(res?.data)) return res.data
    return Object.values(raw || {}).find(Array.isArray) || []
}

const recordOf = (res) => {
    const raw = res?.data?.data ?? res?.data
    return raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : null
}

export const getPaymentOrderStatus = createAsyncThunk('getPaymentOrderStatus', async (data) => {
    const orderId = data?.order_id
    const direct = await statusRequest('payment_transaction/order_status', { order_id: orderId })
    if (direct?.status === 401) return direct
    const directRecord = direct?.status === 200 ? recordOf(direct) : null
    if (directRecord && (directRecord.payment_status || directRecord.status || directRecord.razorpay_order_id)) {
        return direct
    }

    const list = await statusRequest('payment_transaction/list', {
        pageSize: 50,
        pageNo: 0,
        razorpay_order_id: orderId,
    })
    if (list?.status === 401) return list
    if (list?.status === 200) {
        let sessionUser = {}
        try {
            sessionUser = JSON.parse(SessionManager.getCookie('user') || '{}')
        } catch (error) {
            sessionUser = {}
        }
        const match = listRows(list).find((row) => row?.razorpay_order_id === orderId || row?.order_id === orderId)
        const rowUserId = match?.user_id ?? match?.user?.id
        const owned = rowUserId != null && sessionUser?.id != null && String(rowUserId) === String(sessionUser.id)
        if (match && owned) {
            return { status: 200, data: { data: match } }
        }
        return { status: 200, data: { data: { payment_status: 'Pending', razorpay_order_id: orderId } } }
    }

    return direct?.status ? direct : list
})
